import React, { memo } from 'react'
import RemoveIcon from 'transfix-icons/build/RemoveIcon'
import { Button } from 'transfix-ui/components/Button'
import { ICustomerContact } from 'apps/fleet-planner/types'

interface ISubscribersSettingsModalRowProps {
  subscriber: ICustomerContact
  isExternal?: boolean
  shipmentCustomerContact?: ICustomerContact
  onRemove: (subscriber: ICustomerContact) => void
}

export const SubscribersSettingsModalRow = memo<ISubscribersSettingsModalRowProps>(
  ({ isExternal = false, onRemove, shipmentCustomerContact, subscriber }) => {
    const { email, name } = subscriber || {}
    const removeSubscriberHandler = () => {
      onRemove(subscriber)
    }

    // primary customer contact cannot be remove on a External Load
    const noRemoveButton = isExternal && subscriber.sourceContactId === shipmentCustomerContact?.id

    return (
      <div className={`flex pr0 ${!name && 'items-center'}`}>
        <div className='col-md-8 pl0'>
          {!!name && <div>{name}</div>}
          <div className={`${name && ' subscribers-row-subtext'} fs-mask`}>{email}</div>
        </div>
        {!noRemoveButton && (
          <div className='col-md-4 subscribers-row-remove-button'>
            <Button startIcon={<RemoveIcon />} onClick={removeSubscriberHandler}>
              Remove
            </Button>
          </div>
        )}
      </div>
    )
  }
)
